import React from 'react'
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form'

import { FormGroup } from './styles'

type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'defaultValue'>

interface Props<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> extends InputProps {
    name: TName
    control: Control<TFieldValues>
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
    label?: string
}

// eslint-disable-next-line prettier/prettier, max-len
export function Checkbox<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({ name, control, rules, label, ...props }: Props<TFieldValues, TName>): JSX.Element {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <FormGroup className={`form-group ${fieldState.error ? 'has-error' : 'has-success'}`}>
                    {label && <label className="control-label">{label}</label>}
                    <input
                        type="checkbox"
                        className="form-control"
                        ref={field.ref}
                        onChange={field.onChange}
                        checked={field.value}
                        {...props}
                    />
                </FormGroup>
            )}
        />
    )
}
